/**
@license
Copyright (c) 2023 Advensys LLC. All rights reserved.
*/
import { configureStore } from '@reduxjs/toolkit';

import app from './reducers/appSlice.js';
import auth from './reducers/authSlice.js';

import lawyers from './reducers/lawyersSlice.js';
import { lawyerListSelector } from './reducers/lawyersSlice.js';
import lawyer from './reducers/lawyerSlice.js';
import { lawyerSelector } from './reducers/lawyerSlice.js';

import judges from './reducers/judgesSlice.js';
import { judgeListSelector } from './reducers/judgesSlice.js';
import judge from './reducers/judgeSlice.js';
import { judgeSelector } from './reducers/judgeSlice.js';

import legalcases from './reducers/legalcasesSlice.js';
import { legalcasesSelector } from './reducers/legalcasesSlice.js';
import legalcase from './reducers/legalcaseSlice.js';
import { legalcaseSelector } from './reducers/legalcaseSlice.js';


// Sets up a Chrome extension for time travel debugging.
// See https://github.com/zalmoxisus/redux-devtools-extension for more information.
// https://github.com/reduxjs/redux-devtools
const devCompose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// Automatically adds the thunk middleware and the Redux DevTools extension
export const store = configureStore({
  // Automatically calls `combineReducers`
  reducer: {
    app: app,
    auth: auth,
    lawyers: lawyers,
    lawyer: lawyer,
    judges: judges,
    judge: judge,
    legalcases: legalcases,
    legalcase: legalcase,
  },
})
